/* eslint-disable react/jsx-props-no-spreading */
import type { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
// eslint-disable-next-line no-use-before-define
import React from 'react';

import { Meta } from '@/v2/components/global/Meta';
import { ContactUsView } from '@/v2/components/pages/ContactUsView';
import { getContactUsPage } from '@/v2/services/bff/getContactUsPage';

export const getStaticProps = async ({ preview }: GetStaticPropsContext) => {
  const props = await getContactUsPage({ preview });

  return {
    props,
    revalidate: 300,
  };
};

const ContactUsPage = ({
  meta,
  ...rest
}: InferGetStaticPropsType<typeof getStaticProps>) => (
  <>
    <Meta {...meta} />
    <ContactUsView {...rest} />
  </>
);

export default ContactUsPage;
